import filesize from 'filesize'

import {
  ContactSupportDetails,
  ImageDetails,
  MessageTypes,
  Urgency,
  UrgencySelectorItem,
} from './types'

export const IMAGE_LIMIT_SIZE = 2097152
export const CREATE_TICKET_ERROR_MESSAGE =
  'There was a problem creating your ticket. If you continue to encounter this error, you can also submit your ticket in our Product Support Portal at https://support.airship.com.'

export const UPLOAD_IMAGE_SIZE_ERROR_MESSAGE = `Your upload exceeds the maximum file size of ${filesize(
  IMAGE_LIMIT_SIZE
)}.`

export const PRODUCTS_WITH_ADDITIONAL_FIELDS = [
  'web',
  'api',
  'ios',
  'android',
  'push_notification',
  'sdk',
]

export const AIRSHIP_SUPPORT_INSTANCE = 'https://support.airship.com/'
export const AIRSHIP_EU_SUPPORT_INSTANCE = 'https://support.airship.eu/'

export const URGENCY_SELECTOR_ITEMS: UrgencySelectorItem[] = [
  {id: 'low', label: 'Low'},
  {id: 'medium', label: 'Medium'},
  {id: 'highest', label: 'High'},
  {id: 'urgent', label: 'Critical'},
]

export const DEFAULT_IMAGE_DETAILS: ImageDetails = {data: '', name: ''}

export const DEFAULT_CONTACT_SUPPORT_DETAILS: ContactSupportDetails = {
  subject: '',
  issueDescription: '',
  product: '',
  urgency: Urgency.Low,
  image: DEFAULT_IMAGE_DETAILS,
}

export const messageTypes: MessageTypes[] = [
  {id: 'api_push_notification', label: 'Push Notification'},
  {id: 'api_automation', label: 'Automation'},
  {id: 'api_in-app_automation', label: 'In-App Automation'},
  {id: 'api_sequences_and_journeys', label: 'Sequences and Journeys'},
  {id: 'api_scenes', label: 'Scenes'},
  {id: 'api_surveys', label: 'Surveys'},
]
